module.exports = "pegasus/assets/themelp1/simple/105.png";